import React from "react";
import { Link } from "react-router-dom";

const Cards1 = ({ image, title, subtitle, link }) => {
  return (
    <div className="relative w-full group overflow-hidden rounded-xl">
      <img
        src={image}
        className="object-cover w-[500px] h-96 transform transition-transform duration-500 group-hover:scale-110"
        alt="tankkd ou accessoires"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#00000000] to-[#000000]"></div>
      <div className="absolute bottom-20 left-0 right-0 px-4 text-white">
        <h2 className="font-customFont1 text-4xl font-extrabold">{title}</h2>
        <p className="font-customFont2 text-lg font-light">{subtitle}</p>
        <Link to={link} className="relative border rounded-xl  border-[#ffffff] text-[#ffffff] px-4 py-1 group overflow-hidden transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-[#ffffff] hover:text-[#13455a]">Voir les prix</Link>
      </div>
    </div>
    
  );
};

export default Cards1;
